import { Component, Prop } from 'vue-property-decorator';
import { BaseComponent } from '@/components/base-component';
import { CountUpItem } from "@/components/count-up-item/count-up-item";

@Component({
	components: {
		CountUpItem
	}
})
export class CountUp extends BaseComponent {
	@Prop() description: string [];
	@Prop() startVal: number [];
	@Prop() endVal: number [];
	@Prop() duration: number;
	@Prop() sufix: string[];
	@Prop() countItems: number;

}

export default CountUp;
